import React from 'react';

const Sidebar = ({ conversations, onSelectSession, onNewChat, onRefreshConversations, onDeleteSession, selectedModel, onModelChange }) => {
  return (
    <div className="col-md-4 col-lg-3 bg-light p-3 border-end vh-100 overflow-auto">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Conversations</h5>
        <div className="d-flex gap-2">
          <button className="btn btn-success btn-sm" onClick={onNewChat}>
            + New Chat
          </button>
          <button
            onClick={onRefreshConversations}
            className="btn btn-secondary btn-sm"
          >
            🔄 Refresh
          </button>      
          <select
              id="modelSelect"
              value={selectedModel}
              onChange={onModelChange}
            >
              <option value="Gemini">Gemini</option>
            </select>
        </div>
      </div>

      {conversations.map((conv) => (
         <div
          key={conv.id}
          className="d-flex justify-content-between align-items-center p-2 mb-2 bg-white shadow-sm rounded"
        >
          <div onClick={() => onSelectSession(conv.id)} className="cursor-pointer flex-grow-1">
            <strong>{conv.firstMessageText || conv.id}</strong>
          </div>
          <button
            className="btn btn-sm btn-danger ms-2"
            onClick={() => onDeleteSession(conv.id)}
          >
            X
          </button>
        </div>
        
      ))}
    </div>
  );
};

export default Sidebar;
